module.exports = __webpack_public_path__ + "47d603a34cfb2a55a20659e72b30755e.png";